import { render, staticRenderFns } from "./Expositions.vue?vue&type=template&id=5dd491cc&"
import script from "./Expositions.vue?vue&type=script&lang=js&"
export * from "./Expositions.vue?vue&type=script&lang=js&"
import style0 from "./Expositions.vue?vue&type=style&index=0&id=5dd491cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports